// Paden van de inhoudspagina's (inhoud in seoPages.js). Apart gehouden zodat de router
// en App.js de teksten en foto's niet in de eerste download meenemen.
export const SEO_PATHS = ["/online-bestellen-restaurant", "/online-bestellen-traiteur", "/kerstmenu-online-bestellen"];
